import React, { useEffect, useState } from 'react';

import appService from '../../service/app.service';
import { ButtonUI, DialogUI, FormLabelUI, SelectUI } from '../Interface';

const DynamicFormRoleModify = ({ show, onHide, hasPermission, roleId, dynamicFormId, refreshPage, setRefreshPage }) => {
  const [permission, setPermission] = useState(false);

  useEffect(() => {
    setPermission(hasPermission);
  }, [hasPermission, show]);

  const handleChangeRole = async () => {
    appService.updateDynamicFormRolePermission(roleId, dynamicFormId, permission).then(() => {
      setRefreshPage(!refreshPage);
      onHide();
    });
  };

  const options = [
    { value: true, label: 'Jogosult' },
    { value: false, label: 'Nem jogosult' },
  ];

  return (
    <DialogUI open={show} headerContent="Jogosultság módosítás" fullWidth>
      <div className="flex justify-center">
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={permission ?? ''}
            onChange={(event) => setPermission(event.target.value)}
            option={options}
            label={<FormLabelUI text="Jogosultság beállítása" />}
          />
        </div>
      </div>
      <div className="px-4 mt-8 flex justify-center gap-3">
        <ButtonUI text="Hozzáadás" type="button" className="bg-success" onClick={handleChangeRole} />
        <ButtonUI text="Mégse" type="button" onClick={onHide} color="blue-gray" variant="gradient" />
      </div>
    </DialogUI>
  );
};

export default DynamicFormRoleModify;
